import { Flex } from '@chakra-ui/react';
import { Helmet } from 'react-helmet-async';
import { generatePath } from 'react-router-dom';

import { LoadingState } from '../../components/file-browser';
import { SearchResultsContainer } from '../../components/search-results-container/search-results-container';
import * as Routes from '../../constants/routes';
import { useGetDataRoomsQuery } from '../../graphql/generated';
import { useSearchPageQueryParams } from '../../hooks/use-search-page-query-params/use-search-page-query-params';
import { DebounceLoadingState } from '../../ui/debounce-loading/debounce-loading';
import { ErrorState } from '../../ui/errors/error-state';
import { getAvailableDataRooms } from '../../utils/treaty-utils/get-available-data-rooms';

export const navigateToSearchPage = (
  searchParams?: URLSearchParams
): string => {
  const path = generatePath(Routes.SEARCH);

  if (searchParams) {
    const searchParamsString = searchParams.toString();
    return `${path}?${searchParamsString}`;
  }

  return path;
};

export const SearchResultsPage = () => {
  const { params } = useSearchPageQueryParams();
  const { error, loading, data } = useGetDataRoomsQuery();

  if (error) {
    return (
      <ErrorState
        title="An error occurred while performing your search"
        subtitle="Please reach out to the technical support team for further assistance."
      />
    );
  }

  if (loading) {
    return (
      <Flex flex="1" mt="4">
        <DebounceLoadingState>
          <LoadingState />
        </DebounceLoadingState>
      </Flex>
    );
  }

  if (!data?.dataRoomCategories) {
    return (
      <ErrorState
        title="An error occurred while performing your search"
        subtitle="Please reach out to the technical support team for further assistance."
      />
    );
  }

  const availableDataRooms = getAvailableDataRooms(data);

  return (
    <Flex flex="1" data-testid="search-results-page">
      <Helmet>
        <title>Search: {params.searchTerm}</title>
      </Helmet>
      <SearchResultsContainer treaties={availableDataRooms} />
    </Flex>
  );
};
